export const CATERING_MAX_LENGTH = 200;

export const COMMENT_MAX_LENGTH = 70;

export const HEX_COLOR_REGEX =
    /^(?:(?:#|0x)(?:[a-fA-F0-9]{3}|[a-fA-F0-9]{6})|(?:rgb|hsl)a?\([^)]*\))$/;

export const HEX_COLOR_EXTRACTION_REGEX =
    /(?:#|0x)(?:[a-fA-F0-9]{3}|[a-fA-F0-9]{6})\b|(?:rgb|hsl)a?\([^)]*\)/;

/**
 * Returns the first valid hex color substring from a given string, or null if it does not exist.
 * @param hex   Provided string to check for hex color value (might be null for optional colors)
 * @returns     Valid hex color substring
 */
export function getMatchingColor(hex: string | null): string | null {
    if (!hex) return null;
    return hex.match(HEX_COLOR_EXTRACTION_REGEX)?.[0] ?? null;
}
